import { Component, EventEmitter, Input, Output, signal, Signal, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ConfigInput, ConfigSelected } from '../../interfaces/interfaces';
import { ListsService } from '../../services/lists.service';
import { CommonModule } from '@angular/common';
import { InputComponent } from "../input/input.component";
import { SelectedComponent } from "../selected/selected.component";
import { FonpenComponent } from "../fonpen/fonpen.component";
import { ProfessionComponent } from "../profession/profession.component";

@Component({
  selector: 'app-agricultural',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    InputComponent,
    SelectedComponent,
    ProfessionComponent
],
  templateUrl: './agricultural.component.html',
  styleUrl: './agricultural.component.css'
})
export class AgriculturalComponent {
  form: FormGroup;
  
  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: '¿Cuál es tu ingreso por la actividad económica principal?', subLabel: '', formName: 'income', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor ingresa un valor válido' },
    { label: 'Otros Ingresos', subLabel: '', formName: 'incomeExtraActivity', placeholder: '', type: 'number', defaultValue: '', enabled: true, validation: [], textError: 'Por favor ingresa un valor válido' },
  ]);

  dataSelected: WritableSignal<ConfigSelected[]> = signal([
    { label: 'Cuéntanos más de tu actividad', subLabel: '', formName: 'indact', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un valor valido', options: signal([]) },
    { label: '¿Cuál es tu nivel educativo?', subLabel: '', formName: 'academic', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un nivel educativo', options: signal([]) },
    { label: '¿Perteneces a algún grupo de protección especial constitucional?', subLabel: '', formName: 'specialProtecionProgram', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor seleccione un elemento de la lista', options: signal([]) },
  ])

  @Output() formValid = new EventEmitter<any>();
  @Input() defaultData: any;

  constructor(
    private _listService: ListsService,
  ){
    this.form = new FormGroup({
      indact: new FormControl('', [Validators.required]),
      income: new FormControl('', [Validators.required]),
      academic: new FormControl('', [Validators.required]),
      specialProtecionProgram: new FormControl('', [Validators.required]),
      incomeExtraActivity: new FormControl('', [Validators.required]),
      codpro: new FormControl('', [Validators.required]),
    });

    this.form.valueChanges.subscribe(() => {
        this.formValid.emit(this.form.value);
    });
  }

  ngOnInit(): void {
    this.getActivityAgricultural();
    this.getAllAcademicLevels();
    this.getAllSpecialProgram();

    if (this.defaultData) {
      this.dataInputs.update((inputs:any) =>
        inputs.map((input:any) => ({
          ...input,
          defaultValue: this.defaultData[input.formName] ?? input.defaultValue
        }))
      );    
      this.dataSelected.update((inputs:any) =>
        inputs.map((input:any) => ({
          ...input,
          defaultValue: this.defaultData[input.formName] ?? input.defaultValue
        }))
      );
    }
  }


  getActivityAgricultural(){
    this._listService.getSegAgr().subscribe({
      next: (response: any) => {
        this.dataSelected().at(0)?.options.set(response);
      },
      error: (error: any) => {
        console.error('Error loading Seg Agroicultural:', error);
      }
    });
  }
  
  getAllSpecialProgram() {
    this._listService.getAllSpecialProgram().subscribe({
      next: (response: any) => {
        this.dataSelected().at(2)?.options.set(response);
      },
      error: (error: any) => {
        console.error('Error loading special programs:', error);
      }
    });
  }

  getAllAcademicLevels() {
    this._listService.getAllAcademicLevels().subscribe({
      next: (response: any) => {
        this.dataSelected().at(1)?.options.set(response);
      },
      error: (error: any) => {
        console.error('Error loading academic levels:', error);
      }
    });
  }

  handleValue(event: { formName: string, value: string | number }) {
    this.form.get(event.formName)?.setValue(event.value);
  }

  onProfessionSelected(selectedOption: any): void {
    this.form.get('codpro')!.setValue(selectedOption);
  }
}
